<template>
  <md-card>
    <md-card-header :data-background-color="isValid ? dataBackgroundColor : errorDataBackgroundColor">
      <h4 class="title">
        {{ title }}
      </h4>
      <p class="category">
        {{ subTitle }}
      </p>
    </md-card-header>

    <md-card-content>
      <div class="md-layout">
        <div class="md-layout-item md-small-size-50 md-size-50">
          <md-field maxlength="5">
            <label>Data Início</label>
            <md-input
              v-model="selectionDatePeriod.start"
              type="datetime-local"
              :min="minStart"
              :max="selectionDatePeriod.end"
              @change="dataChanged"
            />
          </md-field>
        </div>

        <div class="md-layout-item md-small-size-50 md-size-50">
          <md-field maxlength="5">
            <label>Data Fim</label>
            <md-input
              v-model="selectionDatePeriod.end"
              type="datetime-local"
              :min="selectionDatePeriod.start"
              :max="maxEnd"
              @change="dataChanged"
            />
          </md-field>
        </div>
        
        <div v-if="!isValid" class="md-layout-item md-size-100 text-danger">
          A sua seleção ultrapassou o limite máximo de duração.  
        </div>

        <div class="md-layout-item md-size-100 text-right">
          <md-button
            v-if="!showLoading"
            :disabled="!isValid"
            class="md-raised md-success"
            @click="onClickFetch()"
          >
            BUSCAR
          </md-button>

          <vue-simple-spinner v-if="showLoading" />
        </div>
      </div>
    </md-card-content>
  </md-card>
</template>

<script>
import debounce from "lodash.debounce";
import { DateTime, Duration } from "luxon";

import { DateTimeFormats } from "../util/datetime.formats";

export default {
  name: "PeriodSelector",
  props: {
    dataBackgroundColor: {
      type: String,
      default: "green",
    },
    errorDataBackgroundColor: {
      type: String,
      default: "red",
    },
    title: {
      type: String,
      required: true,
    },
    defaultStart: {
      type: String,
      default: () => DateTime
        .now()
        .toFormat(DateTimeFormats.HTML_INPUT_DATETIME),
    },
    defaultEnd: {
      type: String,
      default: () => DateTime
        .now()
        .plus({ day: 1 })
        .toFormat(DateTimeFormats.HTML_INPUT_DATETIME),
    },
    maxDuration: {
      type: Duration,
      default: undefined,
    },
    subTitle: {
      type: String,
      required: true,
    },
    showLoading: {
      type: Boolean,
      default: false,
    },
    validateOnSelect: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      /** @type {{ start: string, end: string }} */
      selectionDatePeriod: {
        start: this.defaultStart,
        end: this.defaultEnd,
      },
      isValid: true,
    };
  },
  computed: {
    minStart() {
      if (this.validateOnSelect || !this.maxDuration) {
        return null;
      }

      const end = DateTime.fromFormat(this.selectionDatePeriod.end, DateTimeFormats.HTML_INPUT_DATETIME);
      return end
        .minus(this.maxDuration)
        .startOf("day")
        .toFormat(DateTimeFormats.HTML_INPUT_DATETIME);
    },
    maxEnd() {
      if (this.validateOnSelect || !this.maxDuration) {
        return null;
      }

      const start = DateTime.fromFormat(this.selectionDatePeriod.start, DateTimeFormats.HTML_INPUT_DATETIME);
      return start
        .plus(this.maxDuration)
        .endOf("day")
        .toFormat(DateTimeFormats.HTML_INPUT_DATETIME);
    }
  },
  methods: {
    onClickFetch() {
      this.$emit("onClickFetch", this.selectionDatePeriod);
    },
    sendDataChanged: debounce((ctx) => {
      ctx.$emit("dataChanged", ctx.selectionDatePeriod);
    }, 300),
    dataChanged() {
      if (this.validateOnSelect) {
        const start = DateTime.fromFormat(this.selectionDatePeriod.start, DateTimeFormats.HTML_INPUT_DATETIME);
        const end = DateTime.fromFormat(this.selectionDatePeriod.end, DateTimeFormats.HTML_INPUT_DATETIME);

        const min = end.minus(this.maxDuration).startOf("day");
        const max = start.plus(this.maxDuration).endOf("day");

        this.isValid = start >= min && end <= max;
      }
      this.sendDataChanged(this);
    }
  },
};
</script>

<style>
</style>
